<template>
  <div class="container-fluid p-0 bg-overlay" id="admin-login">
    <a href="/live-event" class="home-btn d-none d-sm-block">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    <div class="row no-gutters">
      <!-- <div class="col-lg-4">
        <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
          <div class="w-100">
            <div class="text-center">
              <img src="@/assets/images/logo.svg" height="100" />
              <h4 class="mt-4">
                <i class="fa fa-circle text-danger Blink"></i>
                Live Event Login
              </h4>
            </div>

            <b-alert
              variant="danger"
              v-if="notification && notification.message"
              show
              dismissible
            >
              {{ notification.message }}
            </b-alert>

            <form class="mt-4" @submit.prevent="login">
              <div class="form-group">
                <label>Username</label>
                <input
                  type="text"
                  v-model="email"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                />
                <div v-if="submitted && !$v.email.required" class="invalid-feedback">
                  Username is required
                </div>
              </div>

              <div class="form-group">
                <label>Passcode</label>
                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                />
                <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                  Password is required
                </div>
              </div>

              <button class="btn btn-primary w-100 mt-3" type="submit">
                Login
              </button>
            </form>
          </div>
        </div>
      </div> -->
      <div class="container min-vh-100 d-flex align-items-center justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-8">
          <div class="card shadow-lg border-0">
            <div class="card-body p-4">

              <div class="text-center mb-4">
                <img src="@/assets/images/logo.svg" height="90" />
                <h4 class="mt-3">
                  <i class="fa fa-circle text-danger Blink"></i>
                  Live Event - {{ eventTitle }}
                </h4>
              </div>

              <b-alert
                variant="danger"
                v-if="notification && notification.message"
                show
                dismissible
              >
                {{ notification.message }}
              </b-alert>

              <form class="mt-3" @submit.prevent="moderatorLogin">
                <div class="form-group">
                  <label>Username</label>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div v-if="submitted && !$v.email.required" class="invalid-feedback">
                    Username is required
                  </div>
                </div>

                <div class="form-group mt-3">
                  <label>Passcode</label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                  />
                  <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                    Password is required
                  </div>
                </div>

                <button class="btn btn-primary w-100 mt-4" type="submit">
                  Login
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-8 authentication-bg">
        <div class="bg-overlay"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import MixinRequest from "@/mixins/request";
import { moderator } from "../../../js/path";
import CryptoJS from "crypto-js";

export default {
  mixins: [MixinRequest],

  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      // title: this.$route.params.title,
    };
  },

  validations: {
    email: { required },
    password: { required },
  },

  computed: {
    notification() {
      return this.$store.state.notification;
    },
    eventTitle() {
      return (
        this.$route.params.title ||
        localStorage.getItem('event_title') ||
        ''
      )
    }
  },
  methods: {
    async moderatorLogin() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit("loader/updateStatus", true);

      try {
        const data = await this.postRequest(moderator.moderatorLoginUrl + '/' + this.$route.params.id, {
          username: this.email,
          password: this.password,
        });

        const res = data;
        console.log(res);
        
        const enc = CryptoJS.AES.encrypt(
          JSON.stringify(res),
          process.env.VUE_APP_ENCRYPTION_KEY
        ).toString();

        localStorage.setItem("moderator_token", enc);
        localStorage.setItem("moderator_id", res.moderator_id);
        // localStorage.setItem("moderator_name", res.name);
        // localStorage.setItem("event_id", res.event_id);

        this.$router.push({ name: "moderator-dashboard" });
      } catch (e) {
        this.$store.commit("notification/error", "Invalid credentials");
      }

      this.$store.commit("loader/updateStatus", false);
    },
  },
  mounted() {
    if (this.$route.params.title) {
      localStorage.setItem('event_title', this.$route.params.title)
    }
  }
};
</script>

<style scoped>
.Blink {
  animation: blinker 1.5s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
@keyframes blinker {
  from { opacity: 1; }
  to { opacity: 0; }
}
</style>
